<template>
    <div>
        <form
            id="payment-form"
            @submit.prevent="handleSubmit"
            v-if="isStripe"
        >
            <div id="link-authentication-element"/>
            <div id="payment-element" v-show="!isUpdating"/>
            <div v-show="isUpdating" class="mb-3 mt-5 text-center">Update...</div>
            <button type="submit" id="submit" ref="stripeSubmit" class="hidden">
            </button>
        </form>
        <form class="row payment-credit-card" v-if="!isStripe">
            <div class="col-md-6 mb-4">
                <label class="form-label">Credit Card Number <span class="text-primary">*</span></label>
                <input
                    v-model="creditCard.account"
                    type="text"
                    class="form-control mb-0"
                    v-mask="'#### #### #### ####'"
                    placeholder="0000 0000 0000 0000">
                <!--            <small v-if="validationErrors.phone">{{ validationErrors.phone }}</small>-->
            </div>
            <div class="col-md-6 mb-4">
                <label class="form-label">Expiry Date <span class="text-primary">*</span></label>
                <div class="row">
                    <div class="col-md-6">
                        <input
                            v-model="creditCard.expirationMonth"
                            type="text"
                            class="form-control mb-0"
                            v-mask="'##'"
                            placeholder="MM">
                    </div>
                    <div class="col-md-6">
                        <input
                            v-model="creditCard.expirationYear"
                            type="text"
                            class="form-control mb-0"
                            v-mask="'##'"
                            placeholder="YY">
                    </div>
                </div>
            </div>
            <div class="col-md-6 mb-4">
                <label class="form-label">CVV / CVC number <span class="text-primary">*</span></label>
                <input
                    v-model="creditCard.cvv"
                    type="text"
                    class="form-control mb-0"
                    v-mask="'####'"
                    placeholder="000 / 0000">
            </div>
            <div class="col-md-6 mb-4">
                <slot></slot>
            </div>
        </form>
        <div v-if="isLoading" class="transaction-process fade-in-center-top">
            <p>Please don't reload the page. Transaction in progress.</p>
            <div class="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import CartMixin from "../../../mixins/CartMixin";
import ApiRequest from "../../../utils/api-request";

export default {
    name: "PaymentCreditCard",
    mixins: [CartMixin],
    props: {
        currStep: {
            type: Number,
            default: 0
        },
        referrer: {
            type: String,
            default: ''
        },
        isProduct: {
            type: Boolean,
            default: false
        },
        productShippingAddress: {
            type: String,
            default: ''
        },
        productVariantSelected: {
            type: String,
            default: ''
        },
        productShippingMethod: {
            type: String,
            default: ''
        },
        product: {
            type: Object,
            default: () => {
            }
        },
        isStripe: {
            type: Boolean,
            default: true
        },
        stripeSubmit: {
            type: Boolean,
            default: false
        },
        disableLoader: {
            type: Function,
            default: null
        },
    },
    data() {
        return {
            payload: {},
            stripeObj: null,
            paymentIntent: null,
            idempotencyKey: '',
            elements: null,
            isLoading: false,
            isUpdating: false,
            productData: {
                isProduct: this.isProduct,
                referrer: this.referrer,
                productShippingMethod: this.productShippingMethod,
                productShippingAddress: this.productShippingAddress,
                productVariantSelected: this.productVariantSelected
            },
        }
    },
    watch: {
        stripeSubmit() {
            if (this.stripeSubmit) {
                this.handleFormSubmit();
            }
        },

        productShippingMethod() {
            this.productData.productShippingMethod = this.productShippingMethod;
            if (this.paymentIntent) {
                this.updateStripeElements()
            }
        },

        usedPromoCode() {
            if (this.paymentIntent) {
                this.payload.discount_code = this.usedPromoCode && this.usedPromoCode.code !== undefined ? this.usedPromoCode.code : "";
                this.updateStripeElements()
            }
        },

        productShippingAddress() {
            this.productData.productShippingAddress = this.productShippingAddress;
            this.payload.shipping_address = this.productShippingAddress;
        },
        productVariantSelected() {
            this.productData.productVariantSelected = this.productVariantSelected;
        },
    },
    computed: {
        ...mapGetters('filter', ['journeyDate']),
        ...mapGetters('app', ['stripeKey']),
        ...mapGetters('cart', {
            usedPromoCode: 'promoCode',
        }),
        creditCard: {
            get: function () {
                return this.$store.getters['payment/creditCard'];
            },
            set: function (value) {
                this.$store.commit('payment/SET_CREDIT_CARD', value);
            }
        }
    },
    beforeMount() {
        // this.initCreditCardPayment();
    },
    mounted() {

        this.idempotencyKey = this.generateUUID();

        window.addEventListener("beforeunload", this.beforeUnloadHandler);

        if (this.currStep === 2 || this.isProduct) {
            if (window.Stripe === undefined) {
                let stripeScript = document.createElement('script');
                stripeScript.setAttribute('src', 'https://js.stripe.com/v3/');
                document.head.appendChild(stripeScript);
                stripeScript.onload = () => {
                    this.initStripeElements();
                }
            } else {
                this.initStripeElements();
            }
        }
    },
    beforeDestroy() {
        window.removeEventListener("beforeunload", this.beforeUnloadHandler);
    },
    methods: {
        ...mapActions('payment', ['initCreditCardPayment']),
        beforeUnloadHandler(event) {
            event.preventDefault();
            event.returnValue = true;
            sessionStorage.setItem("_last_payment_id", this.paymentIntent);
            return "Please don't reload the page. Transaction in progress.";
        },
        errorNotify(message) {
            if (message) {
                this.$notify({
                    text: message,
                    type: 'error'
                });
            } else {
                this.$notify({
                    type: 'error',
                    title: 'Server error!',
                    text: 'Something went wrong. Please contact our support service',
                    duration: 5000
                });
            }
        },

        updateStripeElements() {

            if (this.isUpdating) {
                return;
            }

            this.isUpdating = true;
            const $this = this;
            if (this.isProduct) {
                $this.payload = this.createPayload('stripe', this.productData);
            }
            $this.payload['paymentIntent'] = $this.paymentIntent;
            $this.payload['stripeKey'] = this.stripeKey;
            new Promise((resolve, reject) => {
                new ApiRequest().updateStripePaymentIntent($this.payload).then((response) => {
                    if (!response.data.status) {
                        $this.errorNotify(response.data.message);
                        resolve('');
                        return;
                    }
                    $this.isUpdating = false;
                    resolve(response.data.clientSecret);
                }).catch((error) => {
                    $this.errorNotify(error.message || 'Server error!');
                    $this.isUpdating = false;
                    reject(error);
                });
            });
        },
        initStripeElements() {

            if (this.isUpdating || this.paymentIntent) {
                return;
            }
            this.paymentIntent = null;
            this.isUpdating = true;
            this.stripeObj = Stripe(this.stripeKey);
            const $this = this;
            $this.payload = this.createPayload('stripe', this.productData);
            $this.payload['stripeKey'] = this.stripeKey;
            $this.payload['idempotencyKey'] = this.idempotencyKey;
            $this.payload['process'] = 'CREATE PAYMENT INTENT';
            new Promise((resolve, reject) => {
                new ApiRequest().createStripePaymentIntent($this.payload).then((response) => {
                    if (!response.data.status) {
                        $this.errorNotify(response.data.message);
                        this.isUpdating = false;
                        resolve('');
                        return;
                    }

                    $this.paymentIntent = response.data.paymentIntent;

                    $this.elements = this.stripeObj.elements({clientSecret: response.data.clientSecret});
                    const paymentElement = $this.elements.create("payment", {
                        paymentMethodOrder: ['apple_pay', 'google_pay', 'card']
                    });
                    paymentElement.mount("#payment-element");
                    this.isUpdating = false;
                    resolve(response.data.clientSecret);
                }).catch((error) => {
                    $this.errorNotify('');
                    this.isUpdating = false;
                    reject(error);
                });
            });
        },
        handleFormSubmit() {
            this.$refs.stripeSubmit.click()
        },

        disableLoaderAction() {
            this.disableLoader && this.disableLoader();
        },

        captureStripeOrder(payload, amount) {
            const $self = this;
            sessionStorage.removeItem("_last_payment_id");
            return new Promise((resolve, reject) => {
                new ApiRequest().captureStripeOrder(payload).then((response) => {
                    if (!response.data.status) {
                        $self.errorNotify(response.data.message);
                        resolve('');
                        $self.isLoading = false;
                        return;
                    }

                    window.removeEventListener("beforeunload", $self.beforeUnloadHandler);

                    $self.disableLoaderAction();
                    $self.isLoading = false;

                    if($self.elements) {
                        $self.elements.getElement('payment').destroy();
                    }

                    if ($self.isProduct) {

                        try {
                            gtag('event', 'conversion', {
                                'send_to': window.gtag_send_to,
                                'value': (($self.product.price) / 100),
                                'currency': 'USD',
                                'transaction_id': response.data.info.qr,
                                'ref': $self.referrer
                            });
                        } catch (e) {
                            console.error(e.message);
                        }

                        location.href = '/checkout-success/thank-you-purchase/' + btoa(JSON.stringify({
                            data: response.data,
                            product: $self.product.meta.title
                        }));
                    } else {

                        try {
                            gtag('event', 'conversion', {
                                'send_to': window.gtag_send_to,
                                'value': (($self.totalPrice + $self.totalTax - $self.totalDiscount) / 100),
                                'currency': 'USD',
                                'transaction_id': response.data.info.qr,
                                'ref': $self.referrer
                            });
                        } catch (e) {
                            console.error(e.message);
                        }

                        location.href = '/checkout-success/thank-you-' + $self.payload.type + '/' + btoa(JSON.stringify({data: response.data}));
                    }

                    resolve(response.data);
                }).catch((error) => {
                    $self.errorNotify('Something went wrong. Please contact the administrator.');
                    reject(error);
                    $self.disableLoaderAction();
                    $self.isLoading = false;
                });
            });
        },

        isValidDate(payload) {
            if (['rental', 'event', 'tour'].includes(payload.type)) {
                const date = new Date(payload.start);
                return !isNaN(date.getTime());
            }

            return true;
        },

        async handleSubmit(e) {
            e.preventDefault();

            if (this.isLoading) {
                this.disableLoaderAction();
                return;
            }

            this.payload = this.createPayload('stripe', this.productData);

            if(!this.isValidDate( this.payload)) {
                this.$notify({
                    text: 'Please select a valid date',
                    type: 'error'
                });
                return;
            }

            this.isLoading = true;
            const $this = this;

            const {error, paymentIntent} = await this.stripeObj.confirmPayment({
                elements: $this.elements,
                confirmParams: {
                    return_url: `${window.location.origin}`,
                },
                redirect: "if_required",
            });

            if (error && (error.type === "card_error" || error.type === "validation_error")) {
                $this.errorNotify(error.message);
            } else if (paymentIntent && paymentIntent.status === "requires_capture") {
                $this.payload['paymentIntentId'] = paymentIntent.id;
                $this.payload['paymentIntentAmount'] = paymentIntent.amount;
                $this.payload['stripeKey'] = this.stripeKey;
                $this.payload['idempotencyKey'] = this.idempotencyKey;
                $this.payload['process'] = 'SAVE ORDER';
                if($this.elements) {
                    $this.elements.getElement('payment').clear();
                }
                $this.paymentIntent = null;
                $this.stripeObj = null;
                await $this.captureStripeOrder($this.payload, paymentIntent.amount)
            } else if (paymentIntent && paymentIntent.status === "succeeded") {
                $this.payload['paymentIntentId'] = paymentIntent.id;
                $this.payload['paymentIntentAmount'] = paymentIntent.amount;
                $this.payload['stripeKey'] = this.stripeKey;
                $this.payload['idempotencyKey'] = this.idempotencyKey;
                $this.payload['process'] = 'SAVE ORDER';
                if($this.elements) {
                    $this.elements.getElement('payment').clear();
                }
                $this.paymentIntent = null;
                $this.stripeObj = null;
                await $this.captureStripeOrder($this.payload, paymentIntent.amount)
            } else {
                $this.errorNotify("An unexpected error occured.");
            }
            $this.disableLoaderAction();
            this.isLoading = false;
        }
    },
}
</script>

<style scoped>
.transaction-process {
    position: fixed;
    z-index: 100;
    top: 95px;
    min-width: 280px;
    background: #fff;
    width: 50%;
    max-width: 800px;
    left: 50%;
    transform: translate(-50%, 0);
    border-radius: 8px;
    padding: 20px;
    font-size: 24px;
    text-align: center;
    min-height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border: 1px solid red;
    box-shadow: 0 0 10px 3px rgba(0, 0, 0, .1);

    @media (max-width: 992px) {
        width: calc(100% - 40px);
        margin: 0;
    }
}

.transaction-process p {
    font-size: 24px;
}
</style>
